import * as React from "react"
import { SelectAjaxSeeker, SelectSeeker } from "ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate } from 'ui-seeker/utils'

import { getSection } from "app/utils"
import { SelectLoading } from "app/components/loading"
import { COMPETITION_URL } from 'app/@common/constants'


export default function SelectRate({...props}) {
    
    const section = getSection(window.location.href)

    if (props.options?.length) return <SelectSeeker {...props} />

    if (((section === 'competition' || section === 'packages') && !props.sites) || (section !== 'overview' && (!props.date || !props.occupancy || !props.nights))) return <SelectLoading />

    const myProps = {
        urlAjax: COMPETITION_URL.RATES,
        placeholder: 'All cancellation policy',
        isClearable: true,
        method: 'POST',
        icon: { icon: 'chart-line' },
        extraParams: {
            roomID: props.room,
            boardID: props.board,
            dateRange: props.date,
            nights: props.nights, 
            occupancy: props.occupancy, 
            devices: props.devices,
            hotelID: props.hotels,
            info: props.info, 
            ...props.selectedRoute?.length && { routes: props.selectedRoute },
            ...props.sitePackageID?.length ? { sitePackageID: props.sitePackageID } : { id_site: props.sites },
            ...props.refresh && { refresh_cache: props.refresh },
            ...props.id_report_execution && { id_report_execution: props.id_report_execution },
            ...'id_main_hotel' in props && { id_main_hotel: props.id_main_hotel },
            ...props.date === 'custom' && {
                startDate: formatDate(props.customDates[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(props.customDates[1], { format: FORMAT_DATE_BACK })
            }
        },
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}